import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {IonBackButtonDelegate} from '@ionic/angular';

@Component({
  selector: 'app-why-atom-md-header',
  template: `
    <ion-toolbar class="app__header">
      <ion-buttons slot="start" [hidden]="!showBackIcon" class="mr-top-46 mr-bottom-20">
        <ion-back-button [hidden]="!showBackIcon" class="add__color primary-shade" text=""></ion-back-button>
      </ion-buttons>
      <ion-title class="title pd-top-50">
        <ion-label
          class="input-text-label ion-text-left pd-left-38 h2 dark ft-medium no-letter-spacing">{{title}}</ion-label>
        <ion-label
          class="subtitle input-text-label ion-text-left pd-left-38 p2 dark-tint ft-light no-letter-spacing">{{subTitle}}</ion-label>
      </ion-title>
    </ion-toolbar>
  `,
  styleUrls: ['./atom-medium-header.component.scss']
})

export class AtomMediumHeaderComponent implements AfterViewInit {
  @ViewChild(IonBackButtonDelegate) backButton: IonBackButtonDelegate;
  @Input() theme: string = '';
  @Input() showBackIcon: boolean = false;
  @Input() customBackButton: boolean = false;
  @Input() title: string;
  @Input() subTitle: string;
  @Output() customBackButtonAction = new EventEmitter<boolean>();

  constructor(private location: Location) {
  }

  ngAfterViewInit() {
    this.setUIBackButtonAction();
  }

  setUIBackButtonAction() {
    this.backButton.onClick = () => {
      // handle custom action here
      if (this.customBackButton) {
        this.back();
      } else {
        this.location.back();
      }
    };
  }

  back() {
    this.customBackButtonAction.emit(true);
  }
}
